import { Typography, Button } from 'components/UI'

type Props = {
	isUserCollaborator: boolean
	onOpenAddCollaboratorModal: () => void
}

const NoCollaboratorsPlaceholder = ({
	isUserCollaborator,
	onOpenAddCollaboratorModal
}: Props) => (
	<div class='mt-10 flex h-[116px] items-center justify-center gap-5 rounded border border-solid border-black-800'>
		<Typography
			color='text-white'
			text="You haven't invited any collaborators yet"
			variant='text2'
		/>
		<Button
			disabled={isUserCollaborator}
			onClick={onOpenAddCollaboratorModal}
			text='Add Collaborators'
		/>
	</div>
)

export { NoCollaboratorsPlaceholder }
